import {PLUS_CUG_TYPE} from './privateDeals'

export const getPlusCugType = (isMembersPlus: boolean) =>
  isMembersPlus ? [PLUS_CUG_TYPE] : []
